import { observer } from "mobx-react-lite";
import { useCompanyStore } from "../hooks";
import CompanySetupStepOne from "./CompanySetupStepOne";
import CompanySetupStepTwo from "./CompanySetupStepTwo";
import CompanySetupStepThree from "./CompanySetupStepThree";
import CompanySetupStepFour from "./CompanySetupStepFour";
import CompanySetupSummary from "./CompanySetupSummary";

const CompanySetupStepContent = observer(
  ({
    errors,
    getFieldError,
    handleBlur,
    companyNameError,
    companyNameDescription,
    companyNameDescriptionClassName,
  }) => {
    const { step } = useCompanyStore();

    if (step === 1)
      return (
        <CompanySetupStepOne
          companyNameError={companyNameError}
          companyNameDescription={companyNameDescription}
          companyNameDescriptionClassName={companyNameDescriptionClassName}
          getFieldError={getFieldError}
          handleBlur={handleBlur}
        />
      );
    if (step === 2)
      return (
        <CompanySetupStepTwo
          getFieldError={getFieldError}
          handleBlur={handleBlur}
        />
      );
    if (step === 3)
      return (
        <CompanySetupStepThree
          getFieldError={getFieldError}
          handleBlur={handleBlur}
        />
      );
    if (step === 4) return <CompanySetupStepFour errors={errors} />;
    if (step === 5) return <CompanySetupSummary />;
    return null;
  },
);

export default CompanySetupStepContent;
